import { BetType } from "../types/common";
import {
  isSabaComboDisabled,
  providerQueryString,
  SABA_COMBO_MESSAGE,
} from "./providerQuery";

export type FeedQueryType = "normal" | "step" | "stepCombo";

const FEED_QUERY_TYPE_BY_BET_TYPE: Record<BetType, FeedQueryType> = {
  normal: "normal",
  step: "step",
  comboStep: "stepCombo",
};

export const feedQueryType = (betType?: BetType): FeedQueryType => {
  const resolvedBetType = betType ?? "normal";

  return FEED_QUERY_TYPE_BY_BET_TYPE[resolvedBetType];
};

export const feedQueryString = (
  betType?: BetType,
  provider?: string,
  scope?: string,
) => {
  if (betType === "comboStep" && isSabaComboDisabled(provider, scope)) {
    throw new Error(SABA_COMBO_MESSAGE);
  }

  const providerQuery = providerQueryString(provider, scope);
  const providerParam = providerQuery.replace("?", "&");

  return `?type=${feedQueryType(betType)}${providerParam}`;
};
